<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  totalRecords: Number,
  class: String,
})

const lastRow = (total, first, rows) => {
  if (total < first + rows ) {
    return total
  } else {
    return first + rows
  }
}
</script>

<template>
  <Paginator :totalRecords="totalRecords" :class="class">
    <template #start="slotProps">
      {{ slotProps.state.first + 1 }}-{{ lastRow(totalRecords, slotProps.state.first, slotProps.state.rows) }} / {{ totalRecords }}
    </template>
  </Paginator>
</template>